module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body--wrapper",
    attrs: {
      "id": "IndexHome"
    }
  }, [_c('section', {
    staticClass: "banner-top"
  }, [_c('div', {
    staticClass: "banner-top__image-background"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/banner.png"),
      "alt": "Corporate IT Profesional"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "banner-description"
  }, [_c('div', {
    staticClass: "box-desc"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-default",
    attrs: {
      "to": 'about-us'
    }
  }, [_vm._v("\n              About Us\n            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-danger",
    attrs: {
      "to": 'portofolios'
    }
  }, [_vm._v("\n              Portofolio\n            ")])], 1)])])])]), _vm._v(" "), _c('section', {
    staticClass: "intermezo-banner-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-lg btn-warning",
    attrs: {
      "to": 'portofolios'
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v("\n              LIHAT SEMUA PORTOFOLIO\n            ")])], 1)])])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('section', {
    staticClass: "point-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(5), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-block btn-lg btn-warning",
    attrs: {
      "to": 'portofolios'
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v("\n                LIHAT SEMUA PORTOFOLIO\n              ")])], 1)])])])])]), _vm._v(" "), _c('section', {
    staticClass: "section--wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.lates_project), function(project) {
    return _c('div', {
      key: project.id,
      staticClass: "col-md-3"
    }, [_c('div', {
      staticClass: "list-portofolio"
    }, [_c('div', {
      staticClass: "list-portofolio__image"
    }, [_c('img', {
      attrs: {
        "src": project.client_logo_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "box-description"
    }, [_c('router-link', {
      staticClass: "title",
      attrs: {
        "to": 'portofolios/detail/3'
      }
    }, [_vm._v("\n                  " + _vm._s(project.title) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "type"
    }, [_vm._v("\n                  " + _vm._s(project.client_name) + "\n                ")])], 1)])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-danger",
    attrs: {
      "to": 'portofolios'
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v("\n              LIHAT SEMUA PORTOFOLIO\n            ")])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_vm._v("\n              XPIT PILAR "), _c('br'), _vm._v("\n              IT Consultant\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "description"
  }, [_c('p', [_vm._v("Di era digital ini, teknologi informasi menjadi tulang punggung suksesnya bisnis dalam berbagai sektor.\n                Namun, dengan begitu banyaknya pilihan dan kompleksitas teknologi yang terus berkembang, tidaklah mudah\n                untuk menavigasi jalan Anda menuju kesuksesan di dunia digital.")]), _vm._v(" "), _c('p', [_vm._v("Itulah mengapa kami hadir di sini sebagai mitra yang dapat diandalkan untuk membantu Anda memahami,\n                mengimplementasikan, dan memanfaatkan teknologi informasi dengan optimal. Sebagai konsultan IT\n                berpengalaman, kami berkomitmen untuk memberikan solusi terbaik bagi bisnis Anda, membantu Anda\n                mengatasi\n                tantangan teknologi, dan mencapai tujuan bisnis yang lebih tinggi.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n              Ayo Buat aplikasimu sekarang juga!\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section--wrapper service-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "title--top"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n              Our Services\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "service-wrapper__list-service"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "list-service__box-icon"
  }, [_c('img', {
    attrs: {
      "src": "static/images/gallery/service/company-profile.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "list-service__title"
  }, [_vm._v("\n                  Company Profile\n                ")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "list-service__box-icon"
  }, [_c('img', {
    attrs: {
      "src": "static/images/gallery/service/online-shop.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "list-service__title"
  }, [_vm._v("\n                  E-Commerce\n                ")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "list-service__box-icon"
  }, [_c('img', {
    attrs: {
      "src": "static/images/gallery/service/sistem-informasi.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "list-service__title"
  }, [_vm._v("\n                  Sistem Informasi\n                ")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "list-service__box-icon"
  }, [_c('img', {
    attrs: {
      "src": "static/images/gallery/service/world-map.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "list-service__title"
  }, [_vm._v("\n                  Web App\n                ")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "list-service__box-icon"
  }, [_c('img', {
    attrs: {
      "src": "static/images/gallery/service/startup.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "list-service__title"
  }, [_vm._v("\n                  Build Start Up\n                ")])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "point-wrapper__box-title-top"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                  Kebutuhan Teknologi\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n                  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repellat numquam eum incidunt, eos a, magnam\n                  maxime aliquam. A nobis sunt vitae.\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "point-wrapper__box-point"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('p', [_vm._v("Lorem ipsum dolor sit amet")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "point-wrapper__box-counting"
  }, [_c('div', {
    staticClass: "box-head"
  }, [_c('div', {
    staticClass: "count-big"
  }, [_vm._v("\n                    50\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "count-desc"
  }, [_vm._v("\n                    total client\n                  ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('p', [_c('span', [_vm._v("30")]), _vm._v(" company\n                  ")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("10")]), _vm._v(" online store\n                  ")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("05")]), _vm._v(" goverment\n                  ")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("05")]), _vm._v(" personal\n                  ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "title--top"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n              latest project\n            ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19208cf6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/IndexHome.vue
// module id = 75
// module chunks = 0